import type {Product} from '~/types'

// Only the first 3 products get a card, so the section shows only when one of them has a brief.
const TOP_PICKS_COUNT = 3

export const getTopPicksProducts = (products: Product[]) => products?.slice(0, TOP_PICKS_COUNT)

export const shouldShowTopPicks = (products?: Product[]) =>
  getTopPicksProducts(products ?? []).some((product) => product?.brief && !!product.brief.length)
